<template>
  <div class="cadfm-container-horizontal">



    <Main v-show="$route.params.view == 'Main'"
     :lang="lang.Users.Main"></Main>

 </div>
</template>

<script>


import Main from '@/components/Users/Views/Main'


//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Users',
  components:{
    Main,

  },
  props: {
    lang: Object
  },
  data () {
    return {
      sectionPrefix: "u",
      basicView: "Main",
    }
  },
  
  computed: {
    
    

  },
  watch: {

  },
  beforeCreate () {
    
    this.$store.dispatch("setView", "Main");
  },
  created() {
    
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix)
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/Users.vue